import { createApolloFetch } from 'apollo-fetch';
import apolloConfig from '../../config/apolloConfig';

export default (authToken, config, sessionExpiredMessage) => {
  const foodieApiUri = apolloConfig.apiUri;
  const apolloFetch = createApolloFetch({ uri: foodieApiUri });

  /* eslint no-param-reassign: 0 */
  apolloFetch.use(({ options }, next) => {
    if (!options.headers) {
      options.headers = {};
    }
    options.headers.authorization = `Bearer ${authToken}`; //  remove token for test
    // options.headers.authorization = '';//  remove token for test
    next();
  });
  apolloFetch.useAfter(({ response }, next) => {
    if (response.status === 401) {
      if (typeof sessionExpiredMessage === 'function') {
        sessionExpiredMessage();
      }
    }
    next();
  });
  return apolloFetch(config);
};



// WEBPACK FOOTER //
// ./src/graphql/apollo.js